// ja/zh write the family name first. Shared by name display (`formatName`)
// and the Add/Edit test person forms so entry order matches display order.
export const isLastNameFirst = (locale = "en") =>
  locale === "ja" || locale === "zh";
